// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"57a62e10","703":"89f05b0a","787":"2f635e73"}[chunkId] + ".chunk.js";
};